/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useContext } from "react";
import Context from "../../../scripts/context/User";
import axios from "axios";
import { ethers } from "ethers";
import toast from "react-hot-toast";
import { useOutletContext } from "react-router-dom";
import Jazzicon, { jsNumberForAddress } from "react-jazzicon";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DoneIcon from "@mui/icons-material/Done";

import {
  INVALID_NETWORK,
  CONNECT_WALLET,
  HOW_TO_CONNECT_META_MASK,
  SHORTEN_ADDRESS,
} from "./constants";

import { Form } from "./style";

/*
  STATUSES:
    0 - CONNECT_WALLET
    1 - INVALID_NETWORK
    2 - CONNECTED
    3 - already kyc used
    4 - meta mask not installed
*/

export default function LinkWallet() {
  const { globalState, setGlobalState } = useContext(Context);
  const { data, setData, loading, setLoading, handleNext } = useOutletContext();

  async function checkNetwork() {
    const web3 = new ethers.providers.Web3Provider(window.ethereum);
    const network = await web3.getNetwork();

    if (network.chainId !== Number(process.env.REACT_APP_CHAIN_ID)) {
      setData({
        ...data,
        status: 1,
        message: INVALID_NETWORK,
      });
    } else {
      if (data.wallet_address && globalState.registration_step > 4) {
        setData({
          ...data,
          status: 2,
          message: SHORTEN_ADDRESS(data.wallet_address),
        });
      } else {
        setData({
          ...data,
          status: 0,
          message: CONNECT_WALLET,
        });
      }
    }
  }

  useEffect(() => {
    checkNetwork();

    if (data.wallet_address && globalState.registration_step > 4) {
      setData({
        ...data,
        status: 2,
        message: SHORTEN_ADDRESS(data.wallet_address),
      });
    }
  }, []);

  useEffect(() => data.status !== 2 && checkNetwork(), []);

  useEffect(() => {
    if (!window.ethereum || !!window.ethereum.isMetaMask) {
      setData({
        ...data,
        status: 4,
        message: "MetaMask not installed",
      });
    }
  }, []);

  const connectWalletHandler = async () => {
    if (data.status === 1) return;

    if (window.ethereum && window.ethereum.isMetaMask) {
      // get the network chainId from ethers
      const web3 = new ethers.providers.Web3Provider(window.ethereum);
      const network = await web3.getNetwork();

      if (network.chainId !== Number(Number(process.env.REACT_APP_CHAIN_ID))) {
        setData({
          ...data,
          status: 1,
          message: INVALID_NETWORK,
        });
      } else {
        window.ethereum
          .request({ method: "eth_requestAccounts" })
          .then((result) => {
            if (data.status !== 3) {
              setLoading(true);
              axios
                .post("register/wallet_address/checkWalletAddress", {
                  wallet_address: result[0],
                })
                .then(() => {
                  setLoading(false);
                  setData({
                    wallet_address: result[0],
                    status: 2,
                    message: `${result[0].slice(0, 6)}...${result[0].slice(
                      result[0].length - 4
                    )}`,
                  });
                })
                .catch(() => {
                  setLoading(false);
                  setData({
                    wallet_address: result[0],
                    status: 3,
                    message: SHORTEN_ADDRESS(result[0]),
                  });
                });
            }
          })
          .catch((error) => {
            console.log(error.message.message);
          });
      }
    } else {
      setData({
        ...data,
        status: 4,
        message: "MetaMask not found!",
      });
    }
  };

  // listen for account changes
  useEffect(() => {
    window.ethereum?.on("accountsChanged", connectWalletHandler);
    window.ethereum?.on("chainChanged", checkNetwork);

    // stop listening for account changes when unmounting
    return () => {
      window.ethereum?.removeListener("accountsChanged", connectWalletHandler);
      window.ethereum?.removeListener("chainChanged", checkNetwork);
    };
  }, []);

  const submitHandler = (event) => {
    event.preventDefault();
    if (globalState.registration_step > 4) return handleNext();

    if (data.status === 2) {
      setLoading(true);
      axios
        .post("register/wallet_address/saveWalletAddress", {
          wallet_address: data.wallet_address,
        })
        .then(() => {
          setLoading(false);
          setGlobalState({
            ...globalState,
            registration_step: 5,
          });
          handleNext();
        })
        .catch(({ response }) => {
          setLoading(false);
          toast.error(response.data.message);
          setData({ wallet_address: "" });
        });
    }
  };

  return (
    <>
      <div className="pt-lg-0 pt-5 pb-15">
        <h3 className="font-weight-bolder text-white font-size-h2 font-size-h1-lg">
          Link Account to a Theta Wallet Address using MetaMask
        </h3>
      </div>
      <Form id="LinkWallet" onSubmit={submitHandler}>
        {data.status === 1 && (
          <h4 className="text-white-80">
            This system support Theta Chain Only
          </h4>
        )}
        {data.status === 1 && (
          <a
            className="mb-3"
            target="_blank"
            rel="noreferrer"
            href={HOW_TO_CONNECT_META_MASK}
          >
            How to access Theta address through MetaMask?
          </a>
        )}
        {data.status === 3 && (
          <h4 className="text-white-80 mb-3">
            This Address has been used by another account
          </h4>
        )}
        {data.status === 4 && (
          <span className="text-white-80 mb-3">
            Please install MetaMask, to install it{" "}
            <a
              href="https://metamask.io/download/"
              target="_blank"
              rel="noreferrer"
              style={{
                textDecoration: "underline",
              }}
            >
              click here
            </a>
          </span>
        )}
        <div className="pb-15">
          <button
            className={`d-flex btn btn-pill btn-primary align-items-center verify-btn font-weight-bold opacity-90 px-15 py-3${
              [1, 3, 4].includes(data.status) ? " invalid-network-btn" : ""
            }`}
            onClick={connectWalletHandler}
            disabled={loading}
            type="button"
          >
            {data.status === 3 && <HighlightOffIcon />}
            {data.status === 2 && <DoneIcon />}
            {data.message}
            {data.wallet_address && data.status === 2 && (
              <Jazzicon
                diameter={20}
                seed={jsNumberForAddress(data.wallet_address)}
              />
            )}
          </button>
        </div>
      </Form>
    </>
  );
}
